import gql from 'graphql-tag';

export const ListSneakersQuery = gql`
  query($filter: JSON) {
    Sneakers(filter: $filter) {
      _id
      name
      date
      updatedAt
      isDeleted
      colorways {
        _id
      }
    }
  }
`;

export const SneakerDetailsQuery = gql`
  query($id: String!) {
    Sneaker(filter:{_id: $id}) {
      _id
      name
      description
      date
      brand {
        _id
        title
      }
      colorways {
        _id
        nickname
        image
        links {
          _id
          title
          url
        }
      }
    }
    ModelBrands {
      _id
      title
    }
  }
`;

export const CreateSneakerMutation = gql`
  mutation($record: JSON) {
    createSneaker(record: $record) {
      _id
    }
  }
`;

export const UpdateSneakerMutation = gql`
  mutation($id: String!, $update: JSON) {
    updateSneaker(filter: {_id: $id}, update: $update) {
      _id
      name
      date
      isDeleted
    }
  }
`;

export const DeleteSneakerMutation = gql`
  mutation($id: String!) {
    deleteSneaker(query: {_id: $id})
  }
`;

export const TagsAndBrandsQuery = gql`
  {
    ModelBrands {
      _id
      title
    }
    ModelTags {
      _id
      title
    }
  }
`;